<script lang="ts">
    export let task: Task
</script>

{#if task.status == "inProgress"}
    <p>in Bearbeitung</p>
{:else if task.status == "completed"}
    <p>abgeschlossen - Nur noch von Admin bearbeitbar.</p>
{/if}

<style>
    p {
        white-space: normal;
    }
</style>
